import '../components/swiper/home-swiper.js';
import '../components/icon/icon-fab-menu.js';
import '../components/icon/icon-mag.js';
import '../components/icon/icon-user.js';
import '../components/icon/icon-car.js';
export default {
  id: 'e23210982d',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page page-home" data-name="home">\n    <!-- Top Navbar -->\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="right"></div>\n        <div class="title"></div>\n        <div class="right"></div>\n      </div>\n    </div>\n    <!-- 플로팅 버튼 - 메뉴 -->\n    <div class="fab fab-center-bottom color-yellow">\n      <a href="#">\n        <!-- Icons For iOS Theme -->\n        <i class="icon f7-icons if-not-md"><icon-fab-menu></icon-fab-menu></i>\n        <i class="icon f7-icons if-not-md">xmark</i>\n        <!-- Icons For MD Theme -->\n        <i class="icon material-icons md-only"><icon-fab-menu></icon-fab-menu></i>\n        <i class="icon material-icons md-only">close</i>\n      </a>\n      <!-- FAB speed dial actions -->\n      <div class="fab-buttons fab-buttons-left">\n        <a href=""><icon-car></icon-car></a>\n        <a href=""><icon-user></icon-user></a>\n        <a href="/search/"><icon-mag></icon-mag></a>\n      </div>\n    </div>\n    <!-- Toolbar-->\n    <!-- <div class="toolbar toolbar-bottom">\n      <div class="toolbar-inner">\n        <a href="#" class="link">가까운 휴게소</a>\n        <a href="#" class="link">찾기</a>\n        <a href="#" class="link">유저</a>\n      </div>\n    </div> -->\n    <!-- Scrollable page content-->\n    <div class="page-content">\n      <div class="preloader tw-preloader"></div>\n      <home-swiper></home-swiper>      \n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  style: `
  * {
    user-select: none;
  }

  .page-home {
    background-color: rgb(0, 0, 0);
  }

  .page-home > .navbar {
    height: 10vh;
  }

  .navbar .navbar-bg,
  [data-name="home"] .toolbar {
    background-color: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;  
  }

  .page-home .navbar .navbar-inner,
  .page-home .navbar .link {
    color: #ffffff;
  }

  .navbar .navbar-bg::after,
  .navbar .navbar-bg::before {
    display: none;
  }
  .page-home .toolbar::before {
    display: none;
  }
  .page-home .page-content {
    padding: 0;
  }

  .page-home .navbar .right .link .icon {
    font-size: 9.1vw;
  }

  .page-home .fab {
    margin-bottom: 0.6vh;
    will-change: transform;
    transition: transform 300ms ease;

    --f7-theme-color: #BEA36B;
    --f7-theme-color-rgb: #BEA36B;
    --f7-theme-color-shade: #BEA36B;
    --f7-theme-color-tint: #BEA36B;
  }

  .page-home .fab-opened {
    transform: translate3d(14.6vw, 0, 0);
  }

  .page-home .fab-buttons {
    transition: transform 200ms ease;
  }

  .page-home .fab-opened .fab-buttons {
    backdrop-filter: blur(4px);
    background-color: rgba(86, 73, 56, 0.4);
    padding-right: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    transform: translate3d(40px, -5px, 0);
  }

  .page-home .fab > a i.icon {
    font-size: 20px;
  }

  .page-home icon-fab-menu,
  .page-home icon-mag,
  .page-home icon-user,
  .page-home icon-car {
    display: contents;
  }

  .page-home icon-mag svg,
  .page-home icon-user svg,
  .page-home icon-car svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  .tw-preloader {
    position: fixed;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    width: 50px;
    height: 50px;
  }
`,
  styleScoped: false
};